export const PRO_PORTAL_URL = import.meta.env.VITE_PRO_PORTAL_URL;

export const PRO_PORTAL_REDIRECT_FEATURE_FLAG = "redirect-to-pro-portal";
